export default {
  title: 'Dinamica vânzărilor imobiliare',
  x_axis: 'Data',
  y_axis: 'Numărul de vânzări',
  districts: {
    alanya: 'Alanya',
    konyaalti: 'Konyaaltı',
    kemer: 'Kemer',
    kepez: 'Kepez',
    dosemealti: 'Döşemealtı',
    finike: 'Finike'
  }
}
